// @ts-nocheck

import { makeStyles, Switch } from '@material-ui/core';
import React, { useState } from 'react';
import CButton from 'src/component/Button';
import { CStandardInputRefactored } from 'src/component/Input';
import Loader from 'src/component/Loader/Loader';
import { formatDate } from 'src/helpers/millisecondsToFormattedDate';
import { useUpdateProject } from 'src/reactQuery/projects/mutations/useUpdateProject';
import { useProject } from 'src/reactQuery/projects/queries/useProject';

const useStyle = makeStyles({
  gridItem: {
    alignItems: 'center',
    display: 'flex',
    fontFamily: 'Poppins',
    height: '78px'
  },
  headerText: {
    fontSize: '20px',
    fontWeight: 600,
    marginLeft: '20px',
    textAlign: 'start'
  },
  headerWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    width: '100%'
  },
  settingWrapperDiv: {
    '& > div': {
      display: 'flex',
      padding: '20px 0px',
      width: '100%'
    },
    border: '1px solid #CAD8FF',
    borderRadius: '8px',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    minHeight: '125px',
    padding: '0px 20px'
  },
  switchRoot: {
    '& .MuiSwitch-root': {
      padding: '0px'
    }
  },
  switchWrapper: {
    alignItems: 'center',
    display: 'flex',
    height: 'fit-content',
    transform: 'translateX(-12px)'
  },
  workspaceAndRepositoryWrapper: {
    '& > div': {
      alignItems: 'center',
      display: 'flex',
      height: 'fit-content',
      justifyContent: 'space-between'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  wrapperDiv: {
    padding: '1.5rem'
  }
});

const Deployment: React.FC = () => {
  const classes = useStyle();

  const { data, refetch, isLoading } = useProject();
  const deployment = data?.metadata?.deployment;
  const [deploymentDraft, setDeploymentDraft] = useState(deployment);
  const mutation = useUpdateProject({
    onSuccess() {
      refetch();
    }
  });

  const onSave = () => {
    if (data && data.metadata && deploymentDraft) {
      mutation.mutate({
        ...data,
        metadata: {
          ...data.metadata,
          deployment: {
            ...deploymentDraft,
            branch: deploymentDraft.branch || 'main'
          }
        }
      });
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={classes.wrapperDiv}>
      <div className={classes.headerWrapper}>
        <div className={classes.headerText}>Deployment</div>
        <CButton onClick={() => onSave()} type="primary">
          Save
        </CButton>
      </div>
      <div className={classes.settingWrapperDiv}>
        <div className={classes.gridItem}>Turn on manual updates</div>
        <div className={classes.switchWrapper}>
          <Switch
            classes={{ root: classes.switchRoot }}
            color="primary"
            defaultChecked={deployment?.needsContentRebuild!}
            onChange={(event) => {
              setDeploymentDraft({ ...deployment, needsContentRebuild: event.target.checked });
            }}
          />
        </div>
        {deploymentDraft?.needsContentRebuild ? (
          <>
            <div className={classes.gridItem} style={{ paddingBottom: '20px' }}>
              Workspace:
            </div>
            <CStandardInputRefactored
              defaultValue={deployment?.workspace}
              disableUnderline
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setDeploymentDraft({ ...deploymentDraft, workspace: event.target.value });
              }}
            />
          </>
        ) : null}
        {deploymentDraft?.needsContentRebuild ? (
          <>
            <div className={classes.gridItem}>Repository:</div>
            <CStandardInputRefactored
              defaultValue={deployment?.repository}
              disableUnderline
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setDeploymentDraft({ ...deploymentDraft, repository: event.target.value });
              }}
            />
          </>
        ) : null}
        {deploymentDraft?.needsContentRebuild ? (
          <>
            <div className={classes.gridItem}>Main Branch:</div>
            <CStandardInputRefactored
              defaultValue={deployment?.branch || 'main'}
              disableUnderline
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setDeploymentDraft({ ...deploymentDraft, branch: event.target.value });
              }}
            />
          </>
        ) : null}
        <div className={classes.gridItem}>last time contents updated at:</div>
        <div className={classes.gridItem}>
          {deployment?.lastContentModifiedAt ? (
            <div>
              {`${formatDate(new Date(deployment?.lastContentModifiedAt))[0]} At ${
                formatDate(new Date(deployment?.lastContentModifiedAt))[1]
              }`}
            </div>
          ) : null}
        </div>
        <div className={classes.gridItem}>last time deployed at:</div>
        <div className={classes.gridItem}>
          {deployment?.lastDeploymentAt ? (
            <div>
              {`${formatDate(new Date(deployment?.lastDeploymentAt))[0]} At ${
                formatDate(new Date(deployment?.lastDeploymentAt))[1]
              }`}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Deployment;
